import { get as lodashGet } from 'lodash-es';
import { type ValueOf } from 'type-fest';

// Lodash otherHelpers types are not good
// eslint-disable-next-line @stylistic/max-len
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
export const get = <R>(obj: any, key: string, fallback?: R) => (lodashGet(obj, key) ?? fallback) as R;

// Object.keys returns a string[] type
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const keys = <O extends object>(obj: O) => Object.keys(obj) as (keyof O)[];

// Object.entries returns a [string, any][] type
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const entries = <O extends object>(obj: O) => Object.entries(obj) as [keyof O, ValueOf<O>][];
